import { Icon, Stepper } from "vant";
import { getToken } from "@/utils/auth.js";
import { getWXCodeOrToRegister } from "@/utils/login.js";
import { queryLeaseInfo } from "@/api/lease-info.js";
import { querySelfRepay, queryOverHistory } from "@/api/repay-info.js";
import { hkztFormatter, hkztColorFormatter } from "@/utils/formatter.js";
import { wxPayAll, wxPayPart } from "@/api/pay.js";
// import { showToRepay } from "./repay.js";
// import { wxNativePay } from "@/utils/wxpay.js";
export default {
  name: "SelfRepay",
  components: {
    [Icon.name]: Icon,
    [Stepper.name]: Stepper
  },
  data() {
    return {
      list: [],
      total: 0,
      charge: 0,
      showPayDialog: false,
      stepValue: 0,
      stepMin: 0,
      stepMax: 0,
      curSelectItem: null,
      detailList: [],
      show: false
    };
  },
  created() {
    console.log("SelfRepay.vue created");
    getWXCodeOrToRegister(this.$route, this.querySelfRepay);
  },
  mounted() {},
  computed: {},
  watch: {
    curSelectItem(newItem) {
      if (newItem == null) {
        this.stepMin = 0;
        this.stepMax = 0;
      } else {
        this.stepMin = 100;
        this.stepMax = Math.floor(newItem.shje / 100 - 1) * 100;
        this.stepValue = this.stepMax;
      }
    }
  },
  methods: {
    querySelfRepay(openId) {
      this.$toast.loading("加载中...");
      querySelfRepay(openId)
        .then(response => {
          this.$toast.clear();
          console.log(response);
          if (response.data.code === 200) {
            this.list = response.data.results.data;
            this.total = response.data.results.total;
            //无需还款情况下，单个业务跳转至还款计划，多业务跳转合约列表
            if (this.total === 0) {
              this.$dialog.alert({
                message: "当前无需还款，\n为您跳转至服务合同信息"
              });
              //业务信息查询
              queryLeaseInfo(openId)
                .then(response2 => {
                  console.log(response2);
                  if (response2.data.code === 200) {
                    if (response2.data.results.total === 0) {
                      //无业务
                      this.$toast.fail("无服务合同信息");
                    } else if (response2.data.results.total === 1) {
                      //仅一个业务  跳转至业务还款计划列表
                      this.$router.push({
                        name: "RepayInfo",
                        params: {
                          leaseId: response2.data.results.data[0].id,
                          htbh: response2.data.results.data[0].htbh
                        }
                      });
                    } else {
                      //多个业务 跳转至列表
                      this.$router.push({ name: "LeaseInfo" });
                    }
                  }
                })
                .catch(error => {
                  console.error(error);
                });
            }
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    hkztFormatter(hkzt) {
      return hkztFormatter(hkzt);
    },
    hkztColorFormatter(hkzt) {
      return hkztColorFormatter(hkzt);
    },
    // showToRepay(hkzt, hkrq) {
    //   return showToRepay(hkzt, hkrq);
    // },
    //全部支付
    toRepayAll(item) {
      console.log("从后台获取支付的链接");
      const payId = item.id;
      this.$toast.loading("加载中...");
      wxPayAll(payId, getToken(), {})
        .then(response => {
          this.$toast.clear();
          console.log(response);
          if (response.data.code === 200) {
            window.location.href = response.data.results;
          } else if (response.data.code === 201) {
            this.$toast.fail(response.data.message);
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    // 部分支付 不得少于200 且100的整数
    toRepayPart(item) {
      if (item.shje <= 200) {
        this.$toast.fail("200元及以下无法部分还款！");
        return;
      }
      this.showPayDialog = true;
      this.curSelectItem = item;
    },
    onDialogConfirm() {
      console.log("从后台获取支付的链接");
      const payId = this.curSelectItem.id;
      this.$toast.loading("加载中...");
      wxPayPart(payId, this.stepValue, getToken())
        .then(response => {
          this.$toast.clear();
          console.log(response);
          if (response.data.code === 200) {
            window.location.href = response.data.results;
          } else if (response.data.code === 201) {
            this.$toast.fail(response.data.message);
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    onDialogCancel() {
      this.curSelectItem = null;
    },
    //显示未还清历史记录弹框
    showPopup(a, b, leaseId) {
      if (a != b) {
        queryOverHistory(leaseId)
          .then(res => {
            if (res.data.code === 200) {
              this.detailList = res.data.results;
              this.show = true;
            } else {
              this.$toast.loading("请稍候重试");
            }
          })
          .catch(error => {
            this.$toast.loading("请求失败");
            console.log(error);
          });
      }
    }
  }
};
